import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Заявка отправлена',
  description: 'Ожидайте обратную связь по заявке в течение рабочего дня',
  actions: {
    close: 'Закрыть',
    toOrder: 'К заявке',
  },
} satisfies TMessages
